import React, { useEffect, useRef, useState } from 'react';
import axiosClient from "../../services/apiClient";
import { API_URL, READ_PRODUCTS, CREATE_PRODUCT, CHANGE_PRODUCT_STATUS, UPDATE_PRODUCT, DELETE_PRODUCT } from "../../API";
import {Redirect} from "react-router-dom";
import Logo from "../../images/Logo_flomecol.svg";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import AddCircleIcon from "@material-ui/icons/AddCircleOutline";
import AutorenewIcon from '@material-ui/icons/Autorenew';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from "react-bootstrap-table2-paginator";
import InputAdornment from "@material-ui/core/InputAdornment";
import NumberFormat from "react-number-format";
import Edit from "@material-ui/icons/Edit";
import Delete from "@material-ui/icons/Delete";
import Modal from "@material-ui/core/Modal";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import InputBase from "@material-ui/core/InputBase";
import SearchIcon from "@material-ui/icons/Search";
import { calculateLineTaxes, formatTaxAmount } from "../../utils/orderTaxes";
import { PRODUCT_CATEGORIES, productCategoryLabel } from "../../utils/productCategories";


function NumberFormatCustom(props){
    const { inputRef, onChange, ...other } = props;
    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        value: values.value,
                    },
                });
            }}
            decimalScale={0}
            thousandSeparator={","}
            decimalSeparator={"."}
            fixedDecimalScale={true}
            prefix="$ "
        />
    );
}


const normalizeText = (value) => String(value)
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[$,.]/g, '');

const filterProducts = (productsList, searchText) => {
    const tokens = normalizeText(searchText).split(/\s+/).filter((token) => token !== '');
    if(tokens.length === 0){
        return productsList;
    }
    return productsList.filter((product) => tokens.every((token) =>
        product.search_text.includes(token) || product.search_status.startsWith(token)
    ));
}


const AdminProductsComponent = (props) => {

    

    const columns = [
        {
            dataField: 'id',
            text: 'ID',
            sort: true
        },{
            dataField: 'product_name',
            text: 'Nombre',
            sort: true
        },{
            dataField: 'product_presentation',
            text: 'Presentación',
        },{
            dataField: 'product_category_text',
            text: 'Categoría',
        },{
            dataField: 'product_price',
            text: 'Precio',
        },{
            dataField: 'iva_percentage_text',
            text: 'IVA',
        },{
            dataField: 'sugar_tax_text',
            text: 'Imp. azucarado',
        },{
            dataField: 'status',
            text: 'Estado'
        },{
            dataField: 'actions',
            text: 'Acciones',
        }
    ];

    const rowStyle2 = (row, rowIndex) => {
        const style = {};
        if (rowIndex % 2 === 0) {
            style.backgroundColor = '#FFFBCE';
            style.color = '#000000';
            style.height = '45px';
        } else {
            style.backgroundColor = 'white';
            style.height = '45px';
        }

        style.cursor = 'pointer';

        return style;
    };

    const [loadingProducts, setLoadingProducts] = useState(false)
    const [products, setProducts] = useState([])
    const [viewPermission, setViewPermission] = useState(false)
    const [editPermission, setEditPermission] = useState(false)
    const [deletePermission, setDeletePermission] = useState(false)
    const [redirectToLogin, setRedirectToLogin] = useState(false)
    const [editCreateModalOpen, setEditCreateModalOpen] = useState(false)
    const [modalType, setmodalType] = useState('')
    const [productName, setProductName] = useState('')
    const [productPresentation, setProductPresentation] = useState('')
    const [productCategory, setProductCategory] = useState('')
    const [productPrice, setProductPrice] = useState('')
    const [productIva, setProductIva] = useState('')
    const [productSugarTax, setProductSugarTax] = useState('')
    const [loadingCreatingProduct, setLoadingCreatingProduct] = useState(false)
    const [loadingChangeStatus, setLoadingChangeStatus] = useState(false)
    const [loadingEditingProduct, setLoadingEditingProduct] = useState(false)
    const [loadingDeletingProduct, setLoadingDeletingProduct] = useState(false)
    const [currentProductId, setCurrentProductId] = useState(null)
    const [allProducts, setAllProducts] = useState([])
    const [searchText, setSearchText] = useState('')
    // getProducts se invoca desde callbacks creados en renders anteriores, donde el
    // valor de searchText quedaria obsoleto y perderia el filtro activo
    const searchTextRef = useRef('')
  
    useEffect(() => {
        handlePermissions()
    }, [])

    useEffect(() => {
      if(viewPermission || editPermission || deletePermission){
        getProducts()
      }
    }, [viewPermission, editPermission, deletePermission])

    const handlePermissions = () => {
        if(localStorage.getItem('data')){
            let data = JSON.parse(localStorage.getItem('data'));
            switch (data.rol) {
                case 'administracion':
                    setViewPermission(true)
                    setEditPermission(true)
                    setDeletePermission(true)
                    break;
                case 'ventas':
                    setViewPermission(true)
                    setEditPermission(false)
                    break;
                case 'facturacion':
                    setViewPermission(true)
                    setEditPermission(false)
                    break;
                case 'control':
                    setViewPermission(true)
                    setEditPermission(false)
                    break;
                default:
                    break;
            }
        }else{
            setRedirectToLogin(true)
        }
    }

    const getProducts = () => {
        setLoadingProducts(true)
        axiosClient.get(API_URL + READ_PRODUCTS).then((response) => {
            response.data.forEach((product) =>  {
                product.search_text = normalizeText([
                    product.id,
                    product.product_name,
                    product.product_presentation,
                    productCategoryLabel(product.product_category),
                    product.product_price,
                ].join(' '));
                product.search_status = product.status === 'active' ? 'activo' : 'inactivo';

                // null = todavia no clasificado; la categoria la van poblando desde el editor
                product.product_category_text = product.product_category
                    ? productCategoryLabel(product.product_category)
                    : <span className="product-tax-undefined">Sin categoría</span>;

                // null = sin definir (maquilas): no se desglosa en las ordenes
                product.iva_percentage_text = product.iva_percentage === null
                    ? <span className="product-tax-undefined">Sin definir</span>
                    : `${Number(product.iva_percentage)}%`;
                product.sugar_tax_text = product.sugar_tax > 0
                    ? <NumberFormat
                        value={product.sugar_tax}
                        displayType={'text'}
                        prefix={'$'}
                        decimalScale={2}
                        thousandSeparator={","}
                        decimalSeparator={"."}
                        fixedDecimalScale={true}
                    />
                    : '—';

                product.product_price = <NumberFormat
                    value={product.product_price}
                    displayType={'text'}
                    prefix={'$'}
                    decimalScale={0}
                    thousandSeparator={","}
                    decimalSeparator={"."}
                    fixedDecimalScale={true}
                />;


                if(product.status === 'active') {
                    let newStatus = 'inactive'
                    product.status = <div className="product-status-container">
                        <div className="product-status-active"></div>
                        &nbsp;&nbsp;<div>ACTIVO</div>
                        <AutorenewIcon className="product-status-change-icon" onClick={() => changeProductStatus(product.id, newStatus)}/>
                    </div>
                }

                if(product.status === 'inactive') {
                    let newStatus = 'active'
                    product.status = <div className="product-status-container">
                            <div className="product-status-inactive"></div>
                            <div>&nbsp;INACTIVO</div>
                            <AutorenewIcon className="product-status-change-icon" onClick={() => changeProductStatus(product.id, newStatus)}/>
                        </div>
                } 

                product.actions = <React.Fragment>
                    {
                        editPermission &&
                            <Button
                                className='coin-button-table-disable'
                                onClick={() => editProduct(product)}
                            >
                                <Edit/>
                            </Button>
                    }
                    {
                        deletePermission &&
                            <Button
                                className='coin-button-table-disable'
                                onClick={() => deleteProduct(product)}
                            >
                                <Delete/>
                            </Button>
                    }
                </React.Fragment>
            })
            setAllProducts(response.data)
            setProducts(filterProducts(response.data, searchTextRef.current))
            setLoadingProducts(false)
        }).catch((error) => {
            setLoadingProducts(false)
            if(error.response && error.response.data && error.response.data.message){
                alert(error.response.data.message)
            }else{
                alert("ERROR: error de servidor cargando listado de productos")
            }
        })
    }

    const changeProductStatus = (productId, status) => {

        let formData = {
            status,
        }

        setLoadingChangeStatus(true)

        axiosClient.put(API_URL + CHANGE_PRODUCT_STATUS + productId, formData).then((response) => {
            setLoadingChangeStatus(false)
            if(!response.data.success){
                alert("ERROR: error de servidor cambiando estado de producto.")
            }
            getProducts()
        }).catch((error) => {
            setLoadingChangeStatus(false)
            if(error.response && error.response.data && error.response.data.message){
                alert(error.response.data.message)
            }else{
                alert("ERROR: error de servidor cambiando estado de producto.")
            }
        })
    }

    const handleEditCreateModalOpen = () => {
        setEditCreateModalOpen(true)
        setProductName('')
        setProductPresentation('')
        setProductCategory('')
        setProductPrice('')
        setProductIva('19')
        setProductSugarTax('0')
        setmodalType('create')
    }

    const clearProductState = () => {
        setProductName('')
        setProductPresentation('')
        setProductCategory('')
        setProductPrice('')
        setProductIva('')
        setProductSugarTax('')
        setCurrentProductId(null)
    }

    const handleEditCreateModalClose = () => {
        setEditCreateModalOpen(false)
    }

    const handleSearchTextChange = (e) => {
        const text = e.target.value
        searchTextRef.current = text
        setSearchText(text)
        setProducts(filterProducts(allProducts, text))
    }

    const handleProductNameChange = (e) => {
        setProductName(e.target.value)
    }

    const handleProductPresentationChange = (e) => {
        setProductPresentation(e.target.value)
    }

    const handleProductCategoryChange = (e) => {
        setProductCategory(e.target.value)
    }

    const handleProductIvaChange = (e) => {
        setProductIva(e.target.value)
    }

    const handleProductSugarTaxChange = (e) => {
        setProductSugarTax(e.target.value)
    }

    // vacio se guarda como null: producto sin IVA definido
    const taxFieldsPayload = () => ({
        iva_percentage: productIva === '' ? null : parseFloat(productIva),
        sugar_tax: productSugarTax === '' ? 0 : parseFloat(productSugarTax),
    })

    // vacio se guarda como null: producto sin clasificar
    const categoryPayload = () => ({
        product_category: productCategory === '' ? null : productCategory,
    })

    const doCreateProduct = () => {
        if(validateFields()){

            setLoadingCreatingProduct(true)
            
            let formData = {
                product_name: productName, 
                product_presentation: productPresentation,
                product_price: productPrice,
                status: 'active',
                ...categoryPayload(),
                ...taxFieldsPayload(),
            }

            axiosClient.post(API_URL + CREATE_PRODUCT, formData).then((response) => {
                setLoadingCreatingProduct(false)
                if(response.data.success){
                    alert("Producto agregado exitosamente.")
                    setEditCreateModalOpen(false)
                    clearProductState()
                    getProducts()
                }else{
                    alert("ERROR: error de servidor agregando producto.")
                }
                setProducts(response.data)
                setLoadingProducts(false)
            }).catch((error) => {
                setLoadingCreatingProduct(false)
                if(error.response && error.response.data && error.response.data.message){
                    alert(error.response.data.message)
                }else{
                    alert("ERROR: error de servidor agregando producto.")
                }
            })
        }   
    }

    const doEditProduct = () => {
        if(validateFields()){

            setLoadingEditingProduct(true)
            
            let formData = {
                product_name: productName, 
                product_presentation: productPresentation,
                product_price: productPrice,
                ...categoryPayload(),
                ...taxFieldsPayload(),
            }

            axiosClient.put(API_URL + UPDATE_PRODUCT + currentProductId, formData).then((response) => {
                setLoadingEditingProduct(false)
                if(response.data.success){
                    alert("Producto editado exitosamente.")
                    setEditCreateModalOpen(false)
                    clearProductState()
                    getProducts()
                }else{
                    alert("ERROR: error de servidor editando producto.")
                }
                setProducts(response.data)
                setLoadingProducts(false)
            }).catch((error) => {
                setLoadingEditingProduct(false)
                if(error.response && error.response.data && error.response.data.message){
                    alert(error.response.data.message)
                }else{
                    alert("ERROR: error de servidor agregando producto.")
                }
            })
        }   
    }

    const editProduct = (product) => {
        setEditCreateModalOpen(true)
        setmodalType('edit')
        setProductName(product.product_name)
        setProductPresentation(product.product_presentation)
        setProductCategory(product.product_category || '')
        setProductPrice(product.product_price.props.value)
        setProductIva(product.iva_percentage === null ? '' : String(Number(product.iva_percentage)))
        setProductSugarTax(product.sugar_tax ? String(Number(product.sugar_tax)) : '0')
        setCurrentProductId(product.id)
    }

    const deleteProduct = (product) => {
      if(window.confirm("¿Está seguro de que desea eliminar este producto?. Esta es una operación destructiva y no es posible deshacerla.")){
        setLoadingDeletingProduct(true)
        axiosClient.delete(`${API_URL}${DELETE_PRODUCT}${product.id}`).then((response) => {
          setLoadingDeletingProduct(false)
            if(response.data.success){
                alert("Producto eliminado exitosamente.")
                getProducts()
            }else{
                alert("ERROR: error de servidor eliminando producto.")
            }
            setLoadingProducts(false)
        }).catch((error) => {
          setLoadingDeletingProduct(false)
            if(error.response && error.response.data && error.response.data.message){
                alert(error.response.data.message)
            }else{
                alert("ERROR: error de servidor eliminando producto.")
            }
        })
      }
    }

    const handleChange = () => event => {
        let number = parseFloat(event.target.value.substring(2).replace(/,/g, ''));
        setProductPrice(number);
    };

    // NumberFormatCustom entrega el valor sin formato en cada tecla
    const handlePriceChange = (event) => {
        setProductPrice(event.target.value === '' ? '' : parseFloat(event.target.value));
    };

    // el precio guardado es el precio final; la base y el IVA se calculan hacia atras
    const renderPriceBreakdown = () => {
        const taxes = calculateLineTaxes({
            product_price: productPrice,
            iva_percentage: productIva,
            sugar_tax: productSugarTax,
            quantity: 1,
        });
        // base + IVA + azucarado = precio final
        const fields = [
            ['Base sin impuestos', taxes.has_tax_info ? formatTaxAmount(taxes.taxable_base) : 'Sin IVA definido'],
            ['Valor del IVA', taxes.has_tax_info ? formatTaxAmount(taxes.iva) : 'Sin IVA definido'],
            ['Impuesto bebidas azucaradas', formatTaxAmount(parseFloat(productSugarTax) || 0)],
            ['Precio total con impuestos', formatTaxAmount(taxes.line_total)],
        ];
        return [
            <Grid item xs={12} className='inputTextFieldContainer' key='price-breakdown-title'>
                <strong className='create-requested-order-product-select'>DESGLOSE DEL PRECIO (base + IVA + azucarado = precio final)</strong>
            </Grid>,
        ].concat(fields.map(([label, value]) => (
            <Grid item xs={12} md={3} className='inputTextFieldContainer' key={label}>
                <TextField
                    label={label}
                    className='inputTextField'
                    value={value}
                    margin="normal"
                    variant="outlined"
                    disabled={true}
                    fullWidth
                    InputProps={{
                        endAdornment: <InputAdornment position="end">COP</InputAdornment>,
                    }}
                />
            </Grid>
        )));
    };

    const validateFields = () => {
        return validateProductName() && validateProductPresentation() && validateProductPrice() && validateProductTaxes();
    }

    const validateProductTaxes = () => {
        if(productIva !== '' && (isNaN(parseFloat(productIva)) || parseFloat(productIva) < 0 || parseFloat(productIva) > 100)){
            alert("El IVA debe ser un porcentaje entre 0 y 100, o quedar vacío si el producto no lo tiene definido.")
            return false;
        }
        if(productSugarTax !== '' && (isNaN(parseFloat(productSugarTax)) || parseFloat(productSugarTax) < 0)){
            alert("El impuesto a bebidas azucaradas debe ser un valor en pesos mayor o igual a cero.")
            return false;
        }
        return true;
    }

    const validateProductName = () => {
        if(productName === ''){
            alert("Debes ingresar el nombre del producto.")
            return false;
        }else{
            return true;
        }
    }

    const validateProductPresentation = () => {
        if(productPresentation === ''){
            alert("Debes ingresar la presentación del producto.")
            return false;
        }else{
            return true;
        }
    }

    const validateProductPrice = () => {
        if(productPrice === ''){
            alert("Debes ingresar el valor del producto.")
            return false;
        }else{
            return true;
        }
    }


    return (
        <>
            { redirectToLogin && <Redirect push to='/' /> }
            <LoadingComponent loadingImage={Logo} loadingText={'Cargando productos.'} loadingState={loadingProducts}/>
            <LoadingComponent loadingImage={Logo} loadingText={'Creando nuevo producto.'} loadingState={loadingCreatingProduct}/>
            <LoadingComponent loadingImage={Logo} loadingText={'Cambiando estado del producto.'} loadingState={loadingChangeStatus}/>
            <LoadingComponent loadingImage={Logo} loadingText={'Editando producto.'} loadingState={loadingEditingProduct}/>
            <LoadingComponent loadingImage={Logo} loadingText={'Eliminando producto.'} loadingState={loadingDeletingProduct}/>
            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={editCreateModalOpen}
                onClose={() => handleEditCreateModalClose()}
                className='flomecolModalContainer'
            >
                <div className='flomecolModalContent'>

                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            { modalType === 'create' &&  <div className='modalTitle'><h2>NUEVO PRODUCTO</h2></div> }
                            { modalType === 'edit' &&  <div className='modalTitle'><h2>EDITAR PRODUCTO</h2></div> }
                        </Grid>

                        <Grid item xs={12} md={4} className='inputTextFieldContainer'>
                            <TextField
                                id="outlined-name"
                                label="Nombre del Producto"
                                className='inputTextField'
                                name='productName'
                                value={productName}
                                onChange={handleProductNameChange}
                                margin="normal"
                                variant="outlined"
                                fullWidth
                            />
                        </Grid>

                        <Grid item xs={12} md={4} className='inputTextFieldContainer'>
                            <TextField
                                id="outlined-name"
                                label="Presentación del Producto"
                                className='inputTextField'
                                name='productPresentation'
                                value={productPresentation}
                                onChange={handleProductPresentationChange}
                                margin="normal"
                                variant="outlined"
                                fullWidth
                            />
                        </Grid>

                        <Grid item xs={12} md={4} className='inputTextFieldContainer'>
                            <TextField
                                id="outlined-category"
                                select
                                label="Categoría"
                                className='inputTextField'
                                name='productCategory'
                                value={productCategory}
                                onChange={handleProductCategoryChange}
                                margin="normal"
                                variant="outlined"
                                fullWidth
                                helperText="Déjala vacía si el producto aún no está clasificado"
                            >
                                <MenuItem value="">
                                    <em>Sin categoría</em>
                                </MenuItem>
                                {
                                    PRODUCT_CATEGORIES.map((category) => (
                                        <MenuItem key={category.value} value={category.value}>{category.label}</MenuItem>
                                    ))
                                }
                            </TextField>
                        </Grid>

                        <Grid item xs={12} md={4} className='inputTextFieldContainer'>
                            <TextField
                                id="outlined-name"
                                label="Precio del Producto"
                                className='inputTextField'
                                name='productPrice'
                                value={productPrice}
                                onChange={handlePriceChange}
                                onBlur={handleChange('numberformat')}
                                helperText="Precio final a tienda, con IVA e impuestos incluidos"
                                margin="normal"
                                variant="outlined"
                                fullWidth
                                InputProps={{
                                    inputComponent: NumberFormatCustom,
                                    endAdornment: <InputAdornment position="end">COP</InputAdornment>,
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} md={4} className='inputTextFieldContainer'>
                            <TextField
                                id="outlined-iva"
                                label="IVA"
                                className='inputTextField'
                                name='productIva'
                                type='number'
                                value={productIva}
                                onChange={handleProductIvaChange}
                                margin="normal"
                                variant="outlined"
                                fullWidth
                                helperText="Déjalo vacío si el producto no tiene IVA definido (maquilas)"
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} md={4} className='inputTextFieldContainer'>
                            <TextField
                                id="outlined-sugar-tax"
                                label="Impuesto bebidas azucaradas"
                                className='inputTextField'
                                name='productSugarTax'
                                type='number'
                                value={productSugarTax}
                                onChange={handleProductSugarTaxChange}
                                margin="normal"
                                variant="outlined"
                                fullWidth
                                helperText="Valor en pesos por unidad, ya incluido en el precio"
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">COP</InputAdornment>,
                                }}
                            />
                        </Grid>

                        { renderPriceBreakdown() }

                        {
                            modalType === 'create' &&
                                <Grid item xs={12} className='inputTextFieldContainer'>
                                    <Button variant="contained" color="primary" onClick={() => doCreateProduct()}>
                                        <AddCircleIcon/> &nbsp; CREAR NUEVO PRODUCTO
                                    </Button>
                                </Grid>
                        }
                        {   modalType === 'edit' &&
                                <Grid item xs={12} className='inputTextFieldContainer'>
                                    <Button variant="contained" color="primary" onClick={() => doEditProduct()}>
                                        <Edit/> &nbsp; EDITAR PRODUCTO
                                    </Button>
                                </Grid>
                        }
                    </Grid>
                </div>
            </Modal>

            <Grid container spacing={0} className='ModuleMainContainer'>
                {
                    editPermission && <React.Fragment>
                        <Button variant="contained" color="primary" onClick={() => handleEditCreateModalOpen()}>
                            <AddCircleIcon/> &nbsp; CREAR NUEVO PRODUCTO
                        </Button>
                    </React.Fragment>
                }
                <Grid item xs={12}>
                    <div className="clients-search-box">
                        <Grid container spacing={0} alignItems="center" wrap="nowrap">
                            <SearchIcon className="products-search-icon"/>
                            <InputBase
                                placeholder="Buscar producto... (nombre, presentación, precio, ID)"
                                classes={{
                                    root: "clients-search-input-root",
                                    input: "clients-search-input-input",
                                }}
                                style={{ height: '50px' }}
                                value={searchText}
                                onChange={handleSearchTextChange}
                                fullWidth
                            />
                        </Grid>
                    </div>
                </Grid>
                <Grid container spacing={0} className='tables-container'>
                    <Grid item xs={12}>
                        <h3 className='table-title'>
                            LISTADO DE PRODUCTOS
                            { searchText !== '' && ` (${products.length} de ${allProducts.length})` }
                        </h3>
                    </Grid>
                    <Grid item xs={12}>
                        <BootstrapTable
                            keyField='id'
                            data={ products }
                            columns={ columns }
                            rowStyle={ rowStyle2 }
                            classes='bootstrap-table'
                            wrapperClasses='bootstrap-table-wrapper'
                            headerClasses='bootstrap-table-header'
                            pagination={ paginationFactory()}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}
export default AdminProductsComponent